export const ButtonType = {
  SQUARE: {
    status_code: "SQUARE",
    description: "ขอบสี่เหลี่ยม",
    descriptionEn: "square",
  },
  ROUNDED: {
    status_code: "ROUNDED",
    description: "ขอบโค้งมน",
    descriptionEn: "rounded",
  },
  CIRCLE: {
    status_code: "CIRCLE",
    description: "ขอบโค้งกลม",
    descriptionEn: "circle",
  },
} 

 export default  ButtonType;